import {TabTypes} from '../../../types';

// Fields owned by the config tab; anything else (workoutGroups) lives on the edit tab
export const CONFIG_TAB_FIELDS = new Set([
  'name',
  'startDate',
  'endDate',
  'cycleType',
  'target',
  'programIds',
  'programsSelected',
  'usersTargetIds',
  'usersTarget',
  'weekDayIds',
  'showDaysOfWeek',
  'commentEnable',
]);

// Resolve which tab holds the first validation error so it can be made visible
export const resolveErrorTab = (
  errors?: Record<string, string>,
): TabTypes | null => {
  const keys = Object.keys(errors || {});
  if (keys.length === 0) {
    return null;
  }
  if (keys.some((key) => CONFIG_TAB_FIELDS.has(key))) {
    return TabTypes.config;
  }
  return TabTypes.edit;
};
